import type { SVGProps } from "react";

export function IconBlackRocketLaunch(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7834 5.75598C8.06261 5.84676 5.47214 6.96731 3.54085 8.8986L0.189453 12.25H4.28942L10.7834 5.75598ZM11.7501 19.7107V23.8107L15.1015 20.4593C17.0328 18.528 18.1534 15.9375 18.2441 13.2167L11.7501 19.7107ZM19.5816 9.75787C20.9827 7.79955 21.7501 5.43934 21.7501 3V2.25H21.0001C18.5608 2.25 16.2005 3.01742 14.2422 4.41856L7.06077 11.6L12.4001 16.9393L19.5816 9.75787ZM7.06076 15.5L4.94658 17.6142C4.43586 18.1249 4.06372 18.7573 3.8653 19.4518L3.59211 20.408L4.54828 20.1348C5.24275 19.9364 5.8752 19.5642 6.38592 19.0535L8.5001 16.9393L9.56076 18L7.44658 20.1142C6.75561 20.8051 5.89994 21.3086 4.96036 21.5771L1.40808 22.592L2.42302 19.0397C2.69147 18.1001 3.19495 17.2445 3.88592 16.5535L6.0001 14.4393L7.06076 15.5Z"
        fill="#0B0C17"
      />
    </svg>
  );
}
